import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";

export class PlanningRouteMiniSectionOverviewComponent implements IController {
  route: any;
  warnings: any;
  onOpenFullView: Function;

  private dateRange: any;
  private routeMaximumVolume: number | string = "";
  private volumeUnit: any;

  constructor(private splitService) {
  }

  $onInit() {
    this.volumeUnit = this.splitService.getVolumeUnit();
    this.dateRange = {
      from: _.get(_.head(this.route.activities), 'eta'),
      to: _.get(_.last(this.route.activities), 'eta')
    }
    if (_.get(this.route, 'resource.capacity.dimensions.cube')) {
      this.routeMaximumVolume = _.round(_.get(this.route, 'resource.capacity.dimensions.cube'), 1);
    }
  }

  $onChanges(changes) {
    if (changes.route && !changes.route.isFirstChange()) {
      this.$onInit();
    }
  }


}

angular
  .module('bringoz.admin.planning')
  .component('planningRouteMiniSectionOverview', {
    bindings: {
      route: '<',
      warnings: '<?',
      onOpenFullView: '&'
    },
    template: require('./planning-route-mini-section-overview.html').default,
    controller: PlanningRouteMiniSectionOverviewComponent
  });

